import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfirmResponse } from '@app/models';
import {
  CreateVehicleRequest,
  ShareVehicleRequest,
  VehicleDto,
  VehicleType,
} from '@app/models/vehicle.model';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class VehiclesApi extends ApiService {
  static vehiclesPrefix = '/vehicle';

  public getVehicles$(type?: VehicleType): Observable<VehicleDto[]> {
    const params = type ? new HttpParams().set('type', type) : undefined;
    return this.get<VehicleDto[]>(`${VehiclesApi.vehiclesPrefix}/list`, true, {
      params,
    });
  }

  public createVehicle$(body: CreateVehicleRequest): Observable<VehicleDto> {
    return this.post(VehiclesApi.vehiclesPrefix, body);
  }

  public updateVehicle$(
    id: number,
    body: CreateVehicleRequest,
  ): Observable<VehicleDto> {
    return this.put(`${VehiclesApi.vehiclesPrefix}/${id}`, body);
  }

  public removeVehicle$(id: number): Observable<ConfirmResponse> {
    return this.delete(`${VehiclesApi.vehiclesPrefix}/${id}`);
  }

  public shareVehicle$(body: ShareVehicleRequest): Observable<VehicleDto> {
    return this.post(`${VehiclesApi.vehiclesPrefix}/share`, body);
  }

  public unshareVehicle$(id: number): Observable<VehicleDto> {
    return this.post(`${VehiclesApi.vehiclesPrefix}/unshare/${id}`);
  }
}
